import { useRef, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Col,
  Row,
  Select,
  message,
  InputNumber,
  Space,
} from "antd";
import "./FormatoAceptacionPlanCompra.css"; // Aquí va el CSS que te paso abajo
import {
  getDataFormatoAceptacionPlanCompraPatti,
  postFormatoAceptacionPlanCompraPatti,
  putFormatoAceptacionPlanCompraPatti,
} from "../../../../services/financiero/plandecompras/getFormatoAceptacionPlanCompraPattiService";
import { useSelector } from "react-redux";
import CampoPdfEditable from "../FormatoDelegacionFirmaPlanCompra/CampoPdfEditable";

const { Option } = Select;

const meses = [
  { label: "Enero", value: "enero" },
  { label: "Febrero", value: "febrero" },
  { label: "Marzo", value: "marzo" },
  { label: "Abril", value: "abril" },
  { label: "Mayo", value: "mayo" },
  { label: "Junio", value: "junio" },
  { label: "Julio", value: "julio" },
  { label: "Agosto", value: "agosto" },
  { label: "Septiembre", value: "septiembre" },
  { label: "Octubre", value: "octubre" },
  { label: "Noviembre", value: "noviembre" },
  { label: "Diciembre", value: "diciembre" },
];
const FormatoAceptacionPlanCompra = ({
  record,
  existe,
  registroData,
  onClose,
  actualizarDataRegistoLocal,
  updateData
}) => {
  const [form] = Form.useForm();
  const [listaProyectos, setListaProyectos] = useState([]);
  const [listaParticipantes, setListaParticipantes] = useState([]);
  const [listaParticipantesFiltrada, setListaParticipantesFiltrada] = useState(
    []
  );

  const [bienes, setBienes] = useState([]);
  const [proyectoSeleccionado, setProyectoSeleccionado] = useState(null);
  const [tipoProyecto, setTipoProyecto] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [generandoPDF, setGenerandoPDF] = useState(false);
  const pdfRef = useRef();
  const usernameFromState = useSelector((state) => state.auth.user);
  const tipo_formato = 1;

  useEffect(() => {
    const fetchData = async () => {
      if (!record) return;
      form.resetFields(); // Limpia el formulario

      try {
        const resultData = await getDataFormatoAceptacionPlanCompraPatti(
          record
        );

        if (!resultData.status) {
          setBienes([]);
          setListaProyectos([]);
          setListaParticipantes([]);
          return;
        }

        const cantidad = resultData.participantes.length;
        const tipo = cantidad > 1 ? "Asociativo" : "Individual";

        setBienes(resultData.bienes);
        setListaProyectos(resultData.proyectos);
        setListaParticipantes(resultData.participantes);
        setListaParticipantesFiltrada(resultData.participantes);
        setTipoProyecto(tipo);

        form.setFieldsValue({
          tipo_proyecto: tipo,
          numero_personas: cantidad,
        });

        // Autocompletar datos si hay un solo proyecto
        if (resultData.proyectos.length === 1) {
          const proyecto = resultData.proyectos[0];
          setProyectoSeleccionado(proyecto.codigoProyecto);
          form.setFieldsValue({
            titulo_proyecto: proyecto.tituloProyecto,
            linea_productiva: proyecto.lineaProductiva,
            objetivo_proyecto: proyecto.objetivoProyecto,
            codigo_pre: proyecto.codigoProyecto,
            municipio: proyecto.municipio,
            departamento: proyecto.departamento,
            grupo_territorial: proyecto.grupoTerritorial,
            proyecto_selecionado: proyecto.codigoProyecto,
          });
        }

        // Autocompletar si hay un solo participante
        if (resultData.participantes.length === 1) {
          const participante = resultData.participantes[0];
          form.setFieldsValue({
            codigo_sirr: participante.codigoSIRR,
            nombre_titular: participante.nombreTitular,
            numero_cedula: participante.numeroCedula,
            participante_selecionado: participante.codigoSIRR,
          });
        }

        // ✅ MODO EDICIÓN: asignar detalle si existe es true
        if (existe && registroData?.detalle) {
          form.setFieldsValue(registroData.detalle);
          setIsEditing(true);
        } else {
          setIsEditing(false);
        }
      } catch (error) {
        console.error("❌ Error al obtener datos del formato:", error);
      }
    };

    fetchData();
  }, []);

  const onFinish = async (values) => {
    try {
      const user = usernameFromState?.username;

      const detalle = {
        ...values,
        lista_participantes: listaParticipantes,
        lista_bienes: bienes,
      };

      const payload = {
        detalle: detalle,
        user,
      };

      let response;

      if (existe) {
        response = await putFormatoAceptacionPlanCompraPatti(
          registroData.id,
          payload
        );

        if (response?.success === true || response?.status === 200) {
          message.success("Formato actualizado y PDF almacenado correctamente");
          onClose();
          actualizarDataRegistoLocal();
        } else {
          message.warning("No se pudo actualizar el formato correctamente");
        }
      } else {
        response = await postFormatoAceptacionPlanCompraPatti({
          ...payload,
          id_plan_compra: record,
          url: "",
          tipo_formato: tipo_formato,
        });

        if (response?.success === true || response?.status === 200) {
          message.success("Formato registrado y PDF almacenado correctamente");
          onClose();
          actualizarDataRegistoLocal();
          updateData();
        } else {
          message.warning("No se pudo registrar el formato correctamente");
        }
      }
    } catch (error) {
      console.error("❌ Error en onFinish:", error.message || error);
      message.error("Hubo un error al registrar el formato");
    }
  };

  const handleChangeProyecto = (codigoProyecto) => {
    const proyecto = listaProyectos.find(
      (p) => p.codigoProyecto === codigoProyecto
    );

    if (proyecto) {
      form.setFieldsValue({
        titulo_proyecto: proyecto.tituloProyecto,
        linea_productiva: proyecto.lineaProductiva,
        objetivo_proyecto: proyecto.objetivoProyecto,
        codigo_pre: proyecto.codigoProyecto,
        municipio: proyecto.municipio,
        departamento: proyecto.departamento,
        grupo_territorial: proyecto.grupoTerritorial,
      });

      form.setFieldsValue({
        participante_selecionado: null,
        nombre_titular: null,
        numero_cedula: null,
      });
      // Filtrar participantes del proyecto
      const participantesDelProyecto = listaParticipantes.filter(
        (p) => p.codigoProyecto === proyecto.codigoProyecto
      );

      setListaParticipantesFiltrada(participantesDelProyecto);
    }
  };

  const handleChangeParticipante = (codigoSIRR) => {
    const participante = listaParticipantes.find(
      (p) => p.codigoSIRR === codigoSIRR
    );
    if (participante) {
      form.setFieldsValue({
        codigo_sirr: participante.codigoSIRR,
        nombre_titular: participante.nombreTitular,
        numero_cedula: participante.numeroCedula,
      });
    }
  };

  return (
    <div className="container">
      <Form form={form} onFinish={onFinish} layout="vertical">
        <div ref={pdfRef} className="pdf-container">
          <img
            className="banner"
            src="Banner_membrete.png"
            alt="banner"
            style={{
              width: generandoPDF ? "100%" : "100%",
              height: generandoPDF ? "100px" : "auto",
            }}
          />

          <div id="selectores">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Seleccione proyecto"
                  name="proyecto_selecionado"
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Seleccione un proyecto"
                    onChange={handleChangeProyecto}
                    disabled={listaProyectos.length === 1}
                  >
                    {listaProyectos.map((proyecto) => (
                      <Option
                        key={proyecto.codigoProyecto}
                        value={proyecto.codigoProyecto}
                      >
                        {proyecto.codigoProyecto}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Seleccione participante"
                  name="participante_selecionado"
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Seleccione un participante"
                    onChange={handleChangeParticipante}
                    disabled={listaParticipantes.length === 1}
                  >
                    {listaParticipantesFiltrada.map((p) => (
                      <Option key={p.codigoSIRR} value={p.codigoSIRR}>
                        {p.codigoSIRR} - {p.nombreTitular}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </div>

          <table className="excel-table">
            <thead>
              <tr>
                <th colSpan="12" className="title">
                  FORMATO DE ACEPTACIÓN DE PLAN DE COMPRAS PROYECTOS PRODUCTIVOS
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="4">
                  <strong>Titulo del proyecto:</strong>{" "}
                  <CampoPdfEditable
                    name="titulo_proyecto"
                    generandoPDF={generandoPDF}
                  />
                </td>

                <td colSpan="6">
                  <strong>Línea productiva:</strong>{" "}
                  <Form.Item name="linea_productiva" noStyle>
                    <Input
                      variant="borderless"
                      placeholder="Línea productiva"
                    />
                  </Form.Item>
                </td>
                <td rowSpan="2" colSpan="2">
                  <strong>CODA:</strong>{" "}
                  <Form.Item name="codigo_sirr" noStyle>
                    <Input variant="borderless" placeholder="CODA" />
                  </Form.Item>
                </td>
              </tr>
              <tr>
                <td colSpan="10">
                  <strong>Objetivo principal del proyecto: </strong>{" "}
                  <CampoPdfEditable
                    name="objetivo_proyecto"
                    generandoPDF={generandoPDF}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="7">
                  <strong>Nombre completo del titular del proyecto: </strong>{" "}
                  <CampoPdfEditable
                    name="nombre_titular"
                    generandoPDF={generandoPDF}
                  />
                </td>
                <td colSpan="3">
                  <strong>Cédula: </strong>{" "}
                  <CampoPdfEditable
                    name="numero_cedula"
                    generandoPDF={generandoPDF}
                  />
                </td>
                <td colSpan="2">
                  <strong>PRE PP: </strong>{" "}
                  <CampoPdfEditable
                    name="codigo_pre"
                    generandoPDF={generandoPDF}
                  />
                </td>
              </tr>

              <tr>
                <td colSpan="2">
                  <strong>Individual: </strong>
                </td>

                <td colSpan="1">{tipoProyecto === "Individual" ? "X" : ""}</td>

                <td colSpan="2">
                  <strong>Individual Asociativo: </strong>
                </td>

                <td colSpan="1">{tipoProyecto === "Asociativo" ? "X" : ""}</td>

                <td colSpan="6"></td>
              </tr>

              <tr>
                <td colSpan="2">
                  <strong>GRUPO TERRITORIAL </strong>{" "}
                </td>

                <td colSpan="4">
                  <CampoPdfEditable
                    name="grupo_territorial"
                    generandoPDF={generandoPDF}
                  />
                </td>

                <td colSpan="3">
                  <strong>Municipio: </strong>{" "}
                  <CampoPdfEditable
                    name="municipio"
                    generandoPDF={generandoPDF}
                  />
                </td>

                <td colSpan="3">
                  <strong>Departamento: </strong>{" "}
                  <CampoPdfEditable
                    name="departamento"
                    generandoPDF={generandoPDF}
                  />
                </td>
              </tr>

              {/* Fila 7 */}
              <tr>
                <td colSpan="4">
                  <strong>
                    N° DE PERSONAS VINCULADAS AL PROYECTO PRODUCTIVO{" "}
                  </strong>
                </td>

                <td colSpan="1">
                  <CampoPdfEditable
                    name="numero_personas"
                    generandoPDF={generandoPDF}
                  />
                </td>
                <td colSpan="7"></td>
              </tr>

              <tr>
                <td colSpan="12" className="title">
                  INFORMACIÓN DE LAS PERSONAS VINCULADAS AL PROYECTO PRODUCTIVO
                  INDIVIDUAL ASOCIATIVO
                </td>
              </tr>

              <tr>
                <td colSpan="6" className="title">
                  NOMBRES Y APELLIDOS COMPLETOS
                </td>
                <td colSpan="4" className="title">
                  N° Identificación
                </td>
                <td colSpan="2" className="title">
                  CODA - SIR
                </td>
              </tr>

              {/* aqui quede  */}

              {listaParticipantes.map((persona, index) => (
                <tr key={index}>
                  <td colSpan="6">{persona.nombreTitular}</td>
                  <td colSpan="4">{persona.identificacion}</td>
                  <td colSpan="2">{persona.codigoSIRR}</td>
                </tr>
              ))}

              <tr>
                <td colSpan="12" className="title">
                  RELACIÓN DE BIENES A ENTREGAR AL PROYECTO PRODUCTIVO
                </td>
              </tr>
              <tr>
                <td colSpan="1" className="title">
                  ITEM
                </td>
                <td colSpan="4" className="title">
                  DESCRIPCIÓN
                </td>
                <td colSpan="2" className="title">
                  UNIDAD
                </td>
                <td colSpan="2" className="title">
                  CANTIDAD
                </td>

                <td colSpan="3" className="title">
                  OBSERVACIONES
                </td>
              </tr>

              {bienes.length > 0 ? (
                bienes.map((bien, index) => (
                  <tr key={index}>
                    <td colSpan="1">{bien.item}</td>
                    <td colSpan="4">{bien.descripcion}</td>
                    <td colSpan="2">{bien.unidad}</td>
                    <td style={{ textAlign: "center" }} colSpan="2">
                      {bien.cantidad}
                    </td>
                    <td colSpan="3">{bien.observaciones}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="12"
                    style={{ textAlign: "center", fontStyle: "italic" }}
                  >
                    No hay bienes registrados
                  </td>
                </tr>
              )}

              <tr>
                <td
                  colSpan="7"
                  style={{
                    fontWeight: "bold",
                    textAlign: "center",
                    lineHeight: "1.5", // Aumenta el interlineado
                  }}
                >
                  VALOR TOTAL DEL FORTALECIMIENTO AL PROYECTO PRODUCTIVO:
                </td>
                <td colSpan="5">
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).format(listaParticipantes.length * 3000000)}
                </td>
              </tr>

              <tr>
                <td colSpan="12" className="title">
                  * Los valores son estimados y están sujetos a las posibles
                  variaciones de precios presentadas en el mercado al momento de
                  compra a los proveedores.** El valor total incluye el costo
                  del flete hasta el sitio de entrega acordado.
                </td>
              </tr>

              <tr>
                <td colSpan="12" className="title">
                  SITIO DE ENTREGA
                </td>
              </tr>

              <tr>
                <td colSpan="12">
                  <CampoPdfEditable
                    name="sitio_entrega"
                    generandoPDF={generandoPDF}
                  />
                </td>
              </tr>

              <tr>
                <td
                  colSpan="12"
                  style={{
                    fontSize: 14,
                  }}
                >
                  Se valida la anterior información acordada entre el
                  representante del proyecto y el profesional de asistencia
                  técnica para la construcción del Plan de Compras.
                </td>
              </tr>

              <tr>
                <td colSpan={12}>
                  Siendo hoy, día{" "}
                  <Form.Item name="dia" noStyle>
                    <InputNumber
                      min={1}
                      max={31}
                      placeholder="dia"
                      style={{ width: 60 }}
                    />
                  </Form.Item>{" "}
                  mes{" "}
                  <Form.Item name="mes" noStyle>
                    <Select
                      placeholder="Seleccione mes"
                      style={{ width: 140 }}
                      options={meses}
                    />
                  </Form.Item>{" "}
                  de 2025, firman:
                </td>
              </tr>

              <tr>
                <td colSpan="2">NOMBRE PROFESIONAL ASISTENCIA TÉCNICA</td>
                <td colSpan="3">
                  <CampoPdfEditable
                    name="nombre_profesional"
                    generandoPDF={generandoPDF}
                  />
                </td>
                <td colSpan="7">CONFORMIDAD DEL TITULAR DEL PRE-PP</td>
              </tr>

              <tr>
                <td colSpan="2">CÉDULA</td>
                <td colSpan="3">
                  <CampoPdfEditable
                    name="cedula_profesional"
                    generandoPDF={generandoPDF}
                  />
                </td>
                <td colSpan="2" rowSpan="3">
                  PROPUESTA SOCIALIZADA A TITULAR DEL PRE-PP
                </td>
                <td colSpan="4" rowSpan="3">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "4px",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "1px solid black",
                        width: "100%",
                        height: "40px",
                        marginBottom: "8px",
                      }}
                    ></div>
                    <div>Firma</div>
                    <div
                      style={{
                        borderBottom: "1px solid black",
                        width: "100%",
                        height: "40px",
                        marginTop: "8px",
                        marginBottom: "8px",
                      }}
                    ></div>
                    <div>Cédula</div>
                  </div>
                </td>
                <td colSpan="1" rowSpan="3">
                  <div className="huella-cell">Huella</div>
                </td>
              </tr>

              <tr>
                <td colSpan="2" rowSpan="2">
                  FIRMA PROFESIONAL ASISTENCIA TÉCNICA
                </td>
                <td colSpan="3" rowSpan="2"></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginRight: "10px" }}
          >
            {existe ? "✏️ Actualizar registro" : "📄Guardar regisgtro"}
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default FormatoAceptacionPlanCompra;
